export function init ([$slider, $slides]) {
  return () => {
    $slider.classList.add('-animated')
    $slides.forEach(($slide, index) => index == 0
      ? $slide.classList.add('-visible', '-noanimation')
      : $slide.classList.add('-hidden', '-noanimation')
    )
    setImmediate(() =>
      $slides.forEach(($slide, index) => index == 0
        ? $slide.classList.remove('-noanimation')
        : $slide.classList.remove('-noanimation')
      )
    )
  }
}

export function setVisible ([$slides, index]) {
  return () => $slides.forEach(($slide, index_) => index == index_
    ? ($slide.classList.add('-visible'), $slide.classList.remove('-hidden'))
    : ($slide.classList.add('-hidden'), $slide.classList.remove('-visible'))
  )
}


export default {init, setVisible}



// WEBPACK FOOTER //
// ./slider/actions.js